import { Link } from "react-router-dom";
import { PackageX } from "lucide-react";
import { useData } from "../lib/DataContext";
import { PageHeader, Panel } from "../components/shared";
import BundlesPanel from "../components/BundlesPanel";

export default function Bundles() {
  const { policy } = useData();
  const off = policy && policy.enable_bundles === false;
  return (
    <div data-testid="bundles-page">
      <PageHeader kicker="// ITEMS · KITS / BUNDLES" title="Kits / Bundles">
        <Link to="/items" data-testid="bundles-item-master-link" className="h-12 px-4 rounded-md border border-[#334155] text-sm font-semibold flex items-center">Item Master</Link>
      </PageHeader>
      {!policy ? <Panel className="p-6 font-mono text-[#6B7280]">LOADING…</Panel> : off ? (
        <Panel className="p-8 flex items-start gap-4" data-testid="bundles-disabled">
          <PackageX className="w-6 h-6 text-[#F59E0B] shrink-0" />
          <div><div className="font-display text-lg font-bold">Item Bundles are turned off</div>
            <p className="text-sm text-[#9CA3AF] mt-1">Turn on "Enable Item Bundles" in <Link to="/controls" className="text-[#38BDF8] underline">Master Controls</Link> to create bundle SKUs. While off, Shopify orders for bundle SKUs are not exploded and are logged as unmapped.</p></div>
        </Panel>
      ) : <BundlesPanel />}
    </div>
  );
}
